import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Store } from '@ngxs/store';

import { SharedModule } from 'src/app/_shared/_modules/shared.module';

import { VenueState } from '../../../_shared/_ngxs/venue.state';
import { CommonIcon } from 'src/app/_shared/_enums/custom-icons.enum';
import { CommonIcons } from 'src/app/_shared/_enums/digital-storefront-icons.enum';
import { SvgIconService } from 'src/app/_services/svg-icon.service';

@Component({
  selector: 'app-dialog-header',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent {
  @Input() showLogo: boolean = true;
  @Input() showBackButton!: boolean;
  @Input() showOnlyLogoLeft!: boolean;
  @Input() backButtonId!: string;
  @Input() backIcon: CommonIcon | CommonIcons = CommonIcon.AngleLeft;

  public venue$ = this.store.select(VenueState.venue);

  constructor(
    private readonly svgIconService: SvgIconService,
    private readonly store: Store
  ) {
    this.svgIconService.registerSvgIcons([this.backIcon]);
  }
}
